import { BOARD_CHIP_LABELS } from './types';
import type { BoardWorkItemRow } from './types';

export function chipValueFor(
  key: string,
  card: BoardWorkItemRow,
  parentName: string | null,
  assigneeName: string | null = null
): string | null {
  switch (key) {
    case 'type':
      return card.type || null;
    case 'status':
      return card.status || null;
    case 'assignee':
      return assigneeName ?? null;
    case 'priority':
      return card.priority || null;
    case 'due':
      return card.due_date || null;
    case 'epic':
      return parentName;
    default:
      return null;
  }
}

export { BOARD_CHIP_LABELS };
